import { useState } from "react";
import { Box, Grid, Tooltip, IconButton, Typography, Divider,FormControl, } from "@mui/material";

import Backicon from "@mui/icons-material/ArrowBack";
import Saveicon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import Approveicon from "@mui/icons-material/CheckCircle";
import Amendicon from "@mui/icons-material/Edit";
import Printicon from "@mui/icons-material/Print";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ReceiptIcon from '@mui/icons-material/Receipt';

const InvoiceActionMenu = ({
    isVisible,
    fromModule,
    headerText,
    btnSaveUpdate,
    btnSaveTooltip,
    btnSaveText,
    btnCancel,
    btnApprove,
    btnAmendment,
    btnPrint,
    btnGenerateInvoice,
    handleBack,
    handleSave,
    handleCancel,
    handleApprove,
    handleAmendment,
    handlePrint,
    handleGenerateInvoice,
    

}) => {

    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);

        switch (buttonName) {
            case "back":
                handleBack();
                break;
            case "save":
                handleSave(true);
                break;
            case "cancel":
                handleCancel();
                break;
            case "approve":
                handleApprove("Approve Invoice");
                break;
            case "amend":
                handleApprove("Amend Invoice");
                break;
            case "print":
                handlePrint('invoice');
                break;
            case "packinglist":
                handlePrint('packinglist');
                break;
            case "packinglistexport":
                handlePrint('packinglistexport');
                break;
            case "generateinvoice":
                handleGenerateInvoice();
                break;
            default:
                break;
        }
    };

    if (!isVisible) return null;

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Grid container justifyContent="space-between" alignItems="center" padding={0}>
                {/* Left header text */}
                <Grid item>
                    <Typography
                        variant="h4"
                        sx={{ textAlign: "center", ml: 1 }}
                    >
                        {headerText}
                    </Typography>
                </Grid>

                {/* Right action buttons */}
                <Grid item>
                    <Grid container alignItems="center">
                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                        {/* Back */}
                        <Grid item ml={1} mr={1}>
                            <Tooltip title={`Back to ${fromModule} [ALT + B]`}>
                                <IconButton
                                    onClick={() => handleButtonClick("back")}
                                    sx={{ display: "flex", alignItems: "center" }}
                                >
                                    <Backicon style={{ fontSize: 18, color: selectedButton === "back" ? "yellow" : "#009688" }} />
                                    <Typography variant="body2" sx={{ ml: 1 }}>Back</Typography>
                                </IconButton>
                            </Tooltip>
                        </Grid>

                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                        {/* Save */}
                        {btnSaveUpdate && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title={btnSaveTooltip}>
                                        <IconButton
                                            onClick={() => handleButtonClick("save")}
                                            sx={{ display: "flex", alignItems: "center" }}
                                        >
                                            <Saveicon style={{ fontSize: 18, color: selectedButton === "save" ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>{btnSaveText || "Save"}</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}

                        {/* Cancel */}
                        {btnCancel && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title="Cancel Invoice">
                                        <IconButton
                                            onClick={() => handleButtonClick("cancel")}
                                            sx={{ display: "flex", alignItems: "center" }}
                                        >
                                            <CancelIcon style={{ fontSize: 18, color: selectedButton === "cancel" ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Cancel</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}

                        {btnGenerateInvoice && (
                            <Grid item md={0} mr={1}>
                                


                                 <Tooltip title="Generate Invoice">
                                        <IconButton
                                            onClick={() => handleButtonClick("generateinvoice")}
                                            sx={{ display: "flex", alignItems: "center" }}
                                        >
                                            <ReceiptIcon style={{ fontSize: 18, color:  "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Generate Invoice</Typography>
                                        </IconButton>
                                    </Tooltip>

                            </Grid>
                        )}

                        {/* Approve */}
                        {btnApprove && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title="Approve Invoice">
                                        <IconButton
                                            onClick={() => handleButtonClick("approve")}
                                            sx={{ display: "flex", alignItems: "center" }}
                                        >
                                            <Approveicon style={{ fontSize: 18, color: selectedButton === "approve" ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Approve</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}

                        {/* Amend */}
                        {btnAmendment && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title="Amend Invoice">
                                        <IconButton
                                            onClick={() => handleButtonClick("amend")}
                                            sx={{ display: "flex", alignItems: "center" }}
                                        >
                                            <Amendicon style={{ fontSize: 18, color: selectedButton === "amend" ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Amend</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}

                        {/* Print */}
                        {btnPrint && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title="Print Invoice">
                                        <IconButton
                                            onClick={() => handleButtonClick("print")}
                                            sx={{ display: "flex", alignItems: "center" }}
                                        >
                                            <Printicon style={{ fontSize: 18, color: selectedButton === "print" ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Invoice</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}

                        {/* Print */}
                        {btnPrint && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title="Print Packing List">
                                        <IconButton
                                            onClick={() => handleButtonClick("packinglist")}
                                            sx={{ display: "flex", alignItems: "center" }}
                                        >
                                            <Printicon style={{ fontSize: 18, color: selectedButton === "packinglist" ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Packing List</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}

                        {/* Print */}
                        {btnPrint && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title="Download Packing List">
                                        <IconButton
                                            onClick={() => handleButtonClick("packinglistexport")}
                                            sx={{ display: "flex", alignItems: "center" }}
                                        >
                                            <FileDownloadIcon style={{ fontSize: 18, color: selectedButton === "packinglistexport" ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Packing List (Export)</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                {/* <Divider orientation="vertical" flexItem sx={{ mx: 1 }} /> */}
                            </>
                        )}



                    </Grid>
                </Grid>
            </Grid>
            <Divider />
        </Box>
    );
};

export default InvoiceActionMenu;
